import React from 'react';
import { TalentMatchingFilters } from 'talent_matching/types';
import Form from '@grnhse/seedling/lib/birch/components/forms/form';
import { SCORECARD_STATUS } from 'talent_search/shared/types';
import AppReviewTableWrapper from 'talent_matching/components/table/app_review_table_wrapper';
import AdvancedFilter from 'talent_matching/components/filters/advanced_filter';

const PER_PAGE = 50;

export const FORM_DEFAULTS = {
  page: 1,
  perPage: PER_PAGE,
  hideRejected: false,
  jobAlertSubscribers: false,
  feedbackStatus: SCORECARD_STATUS.ALL,
  tags: [],
  locationFilterType: 'radius',
  locationName: '',
  debouncedLocationName: '',
  geolocation: null,
  geolocationRadius: '5',
  degrees: [],
  disciplines: [],
  schools: [],
  applicationFields: [],
  customFields: [],
  appliedOnStart: null,
  appliedOnEnd: null,
  appliedOnType: null,
  jobPosts: [],
  excludePreviouslyRejected: false,
  priorityCandidates: false,
  advancedFilters: [new AdvancedFilter()],
  excludedIds: [],
  savedForLater: false,
  manualReview: false,
  excludeHighRisk: false,
  otherActiveApplications: null,
  minExperience: null,
  maxExperience: null,
  companyNameFilters: [],
  educationFilters: [],
  canHave: [],
  mustHave: [],
  doesNotHave: [],
  questionFilters: [],
};

const FilterForm = ({
  initialFilters,
}: {
  initialFilters: Partial<TalentMatchingFilters>;
}) => {
  const onSubmit = () => {
    // Form is only used to control overall state and apply saved filter states
  };

  return (
    <Form<TalentMatchingFilters>
      defaultValues={{ ...FORM_DEFAULTS, ...initialFilters }}
      onSubmit={onSubmit}
    >
      <AppReviewTableWrapper />
    </Form>
  );
};

export default FilterForm;
